module.exports = __webpack_public_path__ + "img/icon_001.b9302fbf.svg";